// extracted by mini-css-extract-plugin
export default {"buttonDropdown":"DropdownSelector_buttonDropdown__8VFiN","optionsContainer":"DropdownSelector_optionsContainer__IPnNd"};